module.exports = __webpack_public_path__ + "img/dhfesta_productInfo.a4021cda.png";